import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../access-to-public-road.routes';
import { AccessToPublicRoadLocalisationForm } from './forms/access-to-public-road-localisation.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';

@Component({
  selector: 'app-access-to-public-road-localisation-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    ParcelsCrudComponent
  ],
  providers: [AccessToPublicRoadLocalisationForm],
  templateUrl: './access-to-public-road-localisation-section.component.html'
})
export class AccessToPublicRoadLocalisationSectionComponent implements OnDestroy {
  public stages: string[] = stages;

  public form: AccessToPublicRoadLocalisationForm = inject(AccessToPublicRoadLocalisationForm);

  private store$: Store = inject(Store);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public submitAndGoNext(): void {
    const currentApp = this.application();
    if (this.form.valid && currentApp) {
      this.store$.dispatch(updateParcels({
        currentApp,
        payload: this.form.toWriteModel(),
        parcels: this.form.parcelsValues,
        successFnc: (applicationId: string) => {
          this.router.navigate(
            ['../zgody'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
